/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();




// Collections Page JS

function applyFilterClasses() {
  let group_body = document.getElementsByClassName('filter-group__body')
  let group_head = document.getElementsByClassName('filter-group__heading')


  for (let i = 0; i < group_body.length; i++) {
    if (group_body[i].offsetHeight > 220){
      group_body[i].classList.add("collapsed_body");
      group_head[i].classList.add("collapse");
    }
    else{
      group_head[i].addEventListener("click", function(e) {
          e.stopImmediatePropagation();
          e.preventDefault();
          // console.log("Prevent Click and Stop Collapse");
      }, true);
    }
  }
}

// ✅ Observe DOM changes (Shopify replaces filters dynamically)
const targetNode = document.querySelector('.facets, .filter-sidebar, .filters') || document.body;
const observer = new MutationObserver(() => {
  applyFilterClasses();
});

// ✅ Observe only actual changes, not all the time
observer.observe(targetNode, { childList: true, subtree: true });


// Collections Page JS



